export default __webpack_public_path__ + "static/media/not_found_icon.74e4b805.svg";